import React from 'react';
import mygif from '../../assets/mygif.gif';
import './about.css'

const About = () => {
  return (
    <section id="about" className='pt-1 pt-md-5'>
  <div className="container-lg">

    <div className="text-center py-3 mt-md-5">
      <h2>ABOUT ME</h2>
    </div>

      <div className="row justify-content-start align-items-center"> 
          <div className="col-md-6 my-2 text-center">
                <img className="img-fluid mt-3" style={{height: "25rem"}}  src={mygif} alt="woman" />
          </div>
          <div className="col-md-5 col-11 mt-2 mx-4">
          <p className="lead text-black my-2">
          
              <span className='p lead text-md-start text-center about-me'> Hello! I’m Nivedha, a Front End Wed Developer based out of Chennai, India. 
               I worked in Intellect Design Arena for 3 years as a full stack developer. Then I quit to become a freelancer. </span>
               <br /><br />I enjoy bringing ideas to life through the following web technologies.
              
              <span className='skills'>
                <br /> 
                <ul className='mt-2'>
                    <li> HTML/CSS</li> 
                    <li> Javascript</li> 
                    <li> Bootstrap</li> 
                    <li> React.js</li> 
                </ul>
              </span> 
              </p>
          </div>
      </div>
  </div>
</section>
  )
}

export default About